/** Annulation d’une facture figée = avoir numéroté, pas un effacement. */
import { useEffect } from "react";
import { Button } from "../../components/Button";
import "../../components/confirmModal.css";

type CancelInvoiceModalProps = {
  open: boolean;
  number: string;
  amount: string;
  busy?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function CancelInvoiceModal({ open, number, amount, busy, onCancel, onConfirm }: CancelInvoiceModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !busy) onCancel();
    };
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div className="fx-modal" role="dialog" aria-modal="true" aria-labelledby="fx-cancel-inv-title">
      <button type="button" className="fx-modal__backdrop" aria-label="Fermer" disabled={busy} onClick={onCancel} />
      <div className="fx-modal__card is-wide">
        <h2 id="fx-cancel-inv-title" className="fx-modal__title">
          Annuler cette facture {number}
          {amount ? ` · ${amount} TTC` : ""} ?
        </h2>
        <p className="fx-modal__text">On ne la raye pas, on ne la réécrit pas.</p>
        <ul className="fx-modal__list">
          <li>La facture reste figée : son contenu et son empreinte ne changent pas.</li>
          <li>Un avoir est émis immédiatement, numéroté et verrouillé.</li>
          <li>La preuve d’intégrité relie la facture à cet avoir.</li>
        </ul>
        <p className="fx-modal__warn">Cette action est définitive.</p>
        <div className="fx-modal__actions">
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Fermer
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? "Création de l’avoir…" : "Créer l’avoir"}
          </Button>
        </div>
      </div>
    </div>
  );
}
